import waves from './waves'
import { longPress } from './longPress'
import analyticsDirectives from './analytics'

export default {
  install(app) {
    app.directive('waves', waves)
    app.directive('longpress', longPress)
    // 注册埋点相关指令 (v-track, v-track-click, v-page-view)
    analyticsDirectives.install(app)
  }
} 